import { Disclosure } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import type { PropsWithChildren } from "react";

interface AccordionPanelProps extends PropsWithChildren<{}> {
	isOpen: boolean;
}

const AccordionPanel = ({ children, isOpen }: AccordionPanelProps) => {
	return (
		<AnimatePresence>
			{isOpen && children && (
				<Disclosure.Panel
					as={motion.div}
					static
					className="-mb-2 py-2 pl-6"
					initial={{ opacity: 0, y: 5 }}
					animate={{
						opacity: 1,
						y: 0,
						transition: {
							duration: 0.4,
						},
					}}
					exit={{
						opacity: 0,
						y: 5,

						transition: {
							duration: 0.2,
						},
					}}
					key="content"
				>
					<>{children}</>
				</Disclosure.Panel>
			)}
		</AnimatePresence>
	);
};

export default AccordionPanel;
